module.exports = __webpack_public_path__ + "img/icon_card3.862d64d8.png";